import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'components/core/Typography';
import { get } from 'lodash';
import './AdditionalFacilitiesIndicator.scss';

export default function AdditionalFacilitiesIndicator({ location, nearbyTypeName }) {
	return (
		<div className="additional-facilities-banner">
			<Text weight="bold" color="black" highlight="yellow">
				Additional {nearbyTypeName || 'facilities'} near {get(location, 'city', '')}, {get(location, 'state', '')}
			</Text>
		</div>
	);
}

AdditionalFacilitiesIndicator.propTypes = {
	location: PropTypes.shape({
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired
	}).isRequired,
	nearbyTypeName: PropTypes.string
};
